import { StatModule } from "@/core/modules/stat/objects/StatModule";

import ServiceCounterView from "./views/ServiceCounterView.vue";

export const serviceCounter: StatModule = new StatModule("examination", "ServiceCounter", "examination", ServiceCounterView);
